import React, { useEffect, useState } from "react";
import Typewriter from "typewriter-effect";
import { Link } from "react-router-dom";
import "./HeroHeadline.css";

// The typewriter cursor keeps blinking forever, so we hide it once the line
// has finished typing.
const CURSOR_HIDE_DELAY = 8000;

// No colour here any more — these words sit in the heading's own white. The
// italic slant makes the last glyph lean into whatever follows it, so they
// still carry a little optical padding on the right.
const accentStyle = "font-style:italic;padding-right:0.14em";

const HEADLINE_HTML =
  `One Stop for ` +
  `<span style="${accentStyle}">Cryptos</span> & ` +
  `<span style="${accentStyle}">Web3</span>`;

const CTA = { label: "Apply as a Startup", to: "/user/join/crypto?role=founder" };
const CTA_SECONDARY = { label: "Join the Community", to: "/user/join/crypto" };

const HeroHeadline = () => {
  const [cursorHidden, setCursorHidden] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setCursorHidden(true), CURSOR_HIDE_DELAY);
    return () => clearTimeout(timeout);
  }, []);

  // `heroScale` is a hook for the large-screen zoom in HeaderComponent.css.
  return (
    <div
      id="applyHere3"
      className={`${cursorHidden ? "topTyeWriter" : ""} heroScale w-full max-w-5xl px-4 text-center`}
    >
      {/* Font size moved to HeaderComponent.css: it now answers to viewport
          height as well as width, and the `min()`/`calc()` that needs does not
          survive Tailwind's arbitrary-value syntax legibly. */}
      <h1 className="heroTypewriter font-headline font-extrabold tracking-tighter text-white leading-[1.05] m-0 mt-[10px]">
        <Typewriter
          onInit={(typewriter) => typewriter.typeString(HEADLINE_HTML).start()}
        />
      </h1>

      {/* `heroSubcopy` / `heroCtas` below are hooks for the short-screen ramps
          in HeaderComponent.css. The `md:text-xl` and `mt-6` here stay as the
          values every roomy screen gets; the stylesheet only takes height away
          below ~830px of viewport. */}
      <p className="heroSubcopy font-body text-on-surface-variant text-lg md:text-xl leading-relaxed max-w-3xl mx-auto mt-6 mb-0">
        {/* Weight only. These two used to carry a colour of their own; they
            now sit in the paragraph's `text-on-surface-variant` like the rest
            of the sentence. */}
        We are a unique{" "}
        <span className="font-semibold">marketing</span> &{" "}
        <span className="font-semibold">fundraising</span>{" "}
        platform helping accelerate the growth of Blockchain, Crypto & Web3
        projects by combining media, events and access to our community of
        Investors, Mentors & KOLs.
      </p>

      {/* `!justify-center` because several legacy stylesheets redefine a global
          `.flex` rule with `justify-content: space-between`. */}
      <div className="heroCtas flex flex-wrap items-center !justify-center gap-3 mt-7">
        <Link
          to={CTA.to}
          // Matches the navbar's Apply button, down to the near-black label:
          // white on #F0B90A is 1.80:1, #1B2129 is 8.99:1.
          className="group bg-[#F0B90A] !border-0 px-8 py-3.5 rounded-md font-headline font-bold !text-[#1B2129] no-underline hover:bg-[#D1A008] transition-all duration-300 active:scale-95 flex items-center !justify-center gap-2"
        >
          <span className="inline-block group-hover:translate-x-1 transition-transform duration-300">
            {CTA.label}
          </span>
          <span className="material-symbols-outlined text-[18px] group-hover:animate-arrow-slide">
            arrow_forward
          </span>
        </Link>

        <Link
          to={CTA_SECONDARY.to}
          className="group border border-outline-variant/40 px-8 py-3.5 rounded-md font-headline font-bold text-on-surface no-underline hover:border-accent hover:text-white transition-all duration-300 active:scale-95 flex items-center !justify-center"
        >
          <span className="inline-block group-hover:translate-x-1 transition-transform duration-300">
            {CTA_SECONDARY.label}
          </span>
        </Link>
      </div>
    </div>
  );
};

export default HeroHeadline;
